import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const schoolService = {
  list: (p: {
    page?: number; limit?: number; search?: string; is_active?: number;
    city_id?: number; min_commission?: number; max_commission?: number;
    start_date?: string; end_date?: string;
  } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15, locale: 'en' }
    if (p.search) params.search = p.search
    if (p.is_active !== undefined) params.is_active = p.is_active
    if (p.city_id !== undefined) params.city_id = p.city_id
    if (p.min_commission !== undefined) params.min_commission = p.min_commission
    if (p.max_commission !== undefined) params.max_commission = p.max_commission
    if (p.start_date) params.start_date = p.start_date
    if (p.end_date) params.end_date = p.end_date
    return restClient.get(`${endpoints.school.list}?${q(params)}`).then(r => r.data)
  },
  getById: (id: number | string) => restClient.get(`${endpoints.school.details}${id}`).then(r => r.data),
  // Logged-in school admin's own school (auth/vendor/get-vendor)
  myVendor: () => restClient.get(endpoints.school.detailsAdmin).then(r => r.data),
  create:  (data: Record<string, unknown> | FormData) => restClient.post(endpoints.school.create, data).then(r => r.data),
  delete:  (id: number) => restClient.delete(`${endpoints.school.delete}${id}`).then(r => r.data),
  address: (data: Record<string, unknown>) => restClient.post(endpoints.school.address, data).then(r => r.data),
  trainers: (p: { vendor_id?: number; page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.vendor_id) params.vendor_id = p.vendor_id
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.school.trainers}?${q(params)}`).then(r => r.data)
  },
  addTrainer:    (data: Record<string, unknown>) => restClient.post(endpoints.school.addTrainer, data).then(r => r.data),
  removeTrainer: (id: number) => restClient.delete(`${endpoints.school.removeTrainer}${id}`).then(r => r.data),
  schoolTrainers: (p: { vendor_id?: number; page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.vendor_id) params.vendor_id = p.vendor_id
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.school.schoolTrainers}?${q(params)}`).then(r => r.data)
  },
  messageTrainer:  (data: Record<string, unknown>) => restClient.post(endpoints.school.messageToTrainer, data).then(r => r.data),
  packageList:   (p: { page?: number; limit?: number; search?: string; school_id?: number } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15, locale: 'en' }
    if (p.search) params.search = p.search
    if (p.school_id) params.school_id = p.school_id
    return restClient.get(`${endpoints.school.package.getPackageBySchool}?${q(params)}`).then(r => r.data)
  },
}
